import { ServiceNameEnum } from '@Types/index';
import {
  SERVICE_ID_NAME_MAP,
  SERVICE_NAME_ID_MAP,
} from '../../../utils/service';

export const MIN_WITH_SUB_TYPE = 1000;

export enum ThreatType {
  BEC = 'BEC',
  Phishing = 'Phishing',
  Ransomware = 'Ransomware',
  MaliciousFile = 'MaliciousFile',
  MaliciousURL = 'MaliciousURL',
  Spam = 'Spam',
}

export interface Rule {
  ruleName: string;
  services: number[];
  threats: { [threat: string]: number };
  filter: string;
}

export interface Rules {
  [ruleName: string]: Rule;
}

export function formatRules(rawRules: any[]): Rules {
  const rules: Rules = {};
  for (const rawRule of rawRules) {
    if (
      typeof rawRule.ruleName !== 'string' ||
      !Array.isArray(rawRule.services) ||
      !rawRule.threats ||
      typeof rawRule.filter !== 'string'
    ) {
      continue;
    }
    rules[rawRule.ruleName] = rawRule;
  }
  return rules;
}

export interface Report {
  [serviceType: string]: {
    [threat: string]: {
      ruleName: string;
      legal: boolean;
      protection: number;
      filter: string;
    }[];
  };
}

export function formatReport(rules: Rules, rawReport?: any[]): Report | null {
  if (!rawReport) {
    return null;
  }

  const report: Report = {};
  for (const { policyType, ruleName, legal } of rawReport) {
    let service;
    if (
      Math.round(policyType / MIN_WITH_SUB_TYPE) ===
      SERVICE_NAME_ID_MAP['exchange_inline']
    ) {
      if (Math.round(policyType % MIN_WITH_SUB_TYPE) === 0) {
        service = ServiceNameEnum.ExchangeInline + '_inbound';
      } else {
        service = ServiceNameEnum.ExchangeInline + '_outbound';
      }
    } else if (
      Math.round(policyType / MIN_WITH_SUB_TYPE) ===
      SERVICE_NAME_ID_MAP['gmail_inline']
    ) {
      if (Math.round(policyType % MIN_WITH_SUB_TYPE) === 0) {
        service = ServiceNameEnum.GmailInline + '_inbound';
      } else {
        service = ServiceNameEnum.GmailInline + '_outbound';
      }
    } else {
      service = SERVICE_ID_NAME_MAP[policyType];
    }
    if (!service || typeof ruleName !== 'string') {
      continue;
    }
    if (!report[service]) {
      report[service] = {};
    }
    const rule = rules[ruleName];
    if (!rule) {
      continue;
    }
    for (const [threat, protection] of Object.entries(rule.threats)) {
      if (!report[service][threat]) {
        report[service][threat] = [];
      }
      report[service][threat].push({
        ruleName,
        legal: !!legal,
        protection,
        filter: rule.filter,
      });
    }
  }
  return report;
}

export function formatServices(services: string[]): string[] {
  const newSvcs = [];
  for (const svc of services) {
    if (svc === ServiceNameEnum.ExchangeInline) {
      newSvcs.push(ServiceNameEnum.ExchangeInline + '_inbound');
      newSvcs.push(ServiceNameEnum.ExchangeInline + '_outbound');
    } else if (svc === ServiceNameEnum.GmailInline) {
      newSvcs.push(ServiceNameEnum.GmailInline + '_inbound');
      newSvcs.push(ServiceNameEnum.GmailInline + '_outbound');
    } else {
      newSvcs.push(svc);
    }
  }
  return newSvcs;
}
